import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { smartTagKeys } from './query-key-factory';

const GET_SMART_TAGS_ENDPOINT = 'api/smart-tags/get-smart-tag-list';

type GetSmartTagQueryParams = {
  enabled: boolean;
  selectedLspId?: number;
};

export type SmartTag = {
  CreatedBy: string;
  CreatedOnUtc: string;
  Id: number;
  IsDeleted: boolean;
  IsInactive: boolean;
  IsUpdating: boolean;
  LastEditedUtc: string | null;
  Name: string;
};

export const useGetSmartTagsQuery = (request: GetSmartTagQueryParams) => {
  const { enabled = false, selectedLspId = undefined } = request;
  return useQuery({
    queryKey: smartTagKeys.many({ selectedLspId }),
    queryFn: () => fetchData<SmartTag[]>(GET_SMART_TAGS_ENDPOINT, { ...(selectedLspId && { LspId: selectedLspId }) }),
    enabled,
  });
};
